import Constants from '@usas/ui-web/utils/Constants';
import { isValidDate } from '@usas/ui-web/utils/validation';
import { ageRangeErrors } from '../shared/ReportFilterValidation';

export const localValidate = (formState) => {
  let errors = { ...ageRangeErrors(formState) };

  if (formState.orgUnitId === '') {
    errors.orgUnitId = 'Organization is required';
  }

  // Blank stays legal for both. The pickers allow impossible dates like 02/31.
  if (formState.membersAsOfDate !== Constants.BLANK_DATE_STRING
    && isValidDate(formState.membersAsOfDate) === false) {
    errors.membersAsOfDate = 'Members as of Date must be a valid date';
  }

  if (formState.goodStandingAsOfDate !== Constants.BLANK_DATE_STRING
    && isValidDate(formState.goodStandingAsOfDate) === false) {
    errors.goodStandingAsOfDate = 'Course Expirations As Of must be a valid date';
  }

  if (formState.seasonId < 0 && formState.membersAsOfDate === Constants.BLANK_DATE_STRING ) {
    errors.seasonId = 'Select a Season Year or enter a Members as of Date';
  }

  if (formState.seasonId > 0 && formState.membersAsOfDate !== Constants.BLANK_DATE_STRING) {
    errors.membersAsOfDate = 'Cannot enter both a Season Year and a Members as of Date';
  }

  if (formState.genders.length === 0) {
    errors.genders = 'At least one competition category must be selected';
  }

  if (formState.nationalJuniorTeamOnly && formState.nationalTeamOnly) {
    errors.nationalJuniorTeamOnly = 'Cannot select both National Junior Team Only and National Team Only';
  }

  

  return errors;
};

const MembershipDetailReportValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default MembershipDetailReportValidation;